import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer.ts';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1.ts';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';
import {
	DeletePersonRelatedPersonDto,
	GetRelatedPeopleForPerson,
} from '@dealstack/shared/lib/generated';

export const getPersonRelatedPeople = async (
	personId: string
): Promise<GetRelatedPeopleForPerson | undefined> => {
	return await makeRequest<ApiV1.Response<GetRelatedPeopleForPerson>>({
		endpoint: formatUnicorn(API_PATHS.PERSON_PERSONID_RELATED_PEOPLE_GET, {
			personId,
		}),
		method: HTTP_METHOD.GET,
	}).then((response) => response.payload);
};

export const deleteRelatedPerson = async ({
	personId,
	body,
}: {
	personId: string;
	body: DeletePersonRelatedPersonDto;
}): Promise<void> => {
	return await makeRequest<ApiV1.Response<void>>({
		endpoint: formatUnicorn(API_PATHS.PERSON_PERSONID_RELATED_PEOPLE_DELETE, {
			personId,
		}),
		method: HTTP_METHOD.DELETE,
		body: JSON.stringify(body),
	}).then((response) => response.payload);
};
